<template>
  <div class="check-work-body">
    <div style="display: flex;flex-direction: row">
      <div style="width: 200px">
        <area-tree @nodeClick="nodeClick1"></area-tree>
      </div>
      <div>
        <div class="search-wrap">
          <!--          <el-button size="mini" type="primary" @click="editArticle()" style="margin-right: 5px;" icon="el-icon-plus">添加</el-button>-->
          <el-input size="mini" placeholder="客户名称/项目名称/发票号" v-model="keyword" clearable style="width: 200px"></el-input>
          <el-select size="mini" v-model="time_type" placeholder="筛选类型">
            <el-option label="合同月份" value="contract_month"></el-option>
            <el-option label="回款时间" value="invoice_type"></el-option>
          </el-select>
          <el-date-picker v-if="time_type === 'contract_month'"
                          size="mini"
                          v-model="month_value"
                          type="month"
                          format="yyyy-MM"
                          value-format="yyyy-MM"
                          placeholder="选择月">
          </el-date-picker>
          <el-date-picker v-else
                          size="mini"
                          v-model="income_time"
                          type="daterange"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          placeholder="选择日期">
          </el-date-picker>

          <el-select size="mini" v-model="entry_type_name" placeholder="业务类型" clearable>
            <el-option
              v-for="item in business_list"
              :key="item.id"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>

<!--          <el-select size="mini" v-model="f_status" placeholder="审核状态" clearable>-->
<!--            <el-option-->
<!--              v-for="item in [{'name':'全部','value':'3,4'},{'name':'未审','value':'3'},{'name':'已审','value':'4'}]"-->
<!--              :key="item.name"-->
<!--              :label="item.name"-->
<!--              :value="item.value">-->
<!--            </el-option>-->
<!--          </el-select>-->

          <el-button size="mini" type="primary" @click="search">搜索</el-button>
          <el-button size="mini" @click="download" >导出</el-button>

          <div style="width: 30px;display: inline-block;"></div>

          <el-button size="mini" type="success" v-if="multipleSelection.length" @click="approve()">审核</el-button>
          <!--          <el-button size="mini" type="primary" v-if="multipleSelection.length" @click="invoices()">开发票</el-button>-->
          <!--          - -->
          <!--          <el-button size="mini" type="primary" @click="exportExcel">导出</el-button>-->
          <!--          <el-button size="mini" type="primary" @click="importExcel">导入</el-button>-->
        </div>

        <div class="table-wrap">
          <el-table v-if="pageData" v-loading="loading" :data="pageData.list" @selection-change="handleSelectionChange">
<!--            <el-table-column-->
<!--              type="selection"-->
<!--              :selectable="selectable"-->
<!--              width="55">-->
<!--            </el-table-column>-->
            <el-table-column prop="party_a" label="客户名称" align="center" width="200"></el-table-column>
            <el-table-column prop="project_name" label="项目名称" align="center" width="200"></el-table-column>
            <el-table-column prop="entry_type_name" label="业务类型" align="center" width="80"></el-table-column>
            <el-table-column prop="month" label="应收月份" width="100" align="center"></el-table-column>
            <el-table-column prop="income_amount" label="回款金额" align="center"></el-table-column>
            <el-table-column prop="income_time" label="回款日期" align="center" width="100">
            </el-table-column>
            <el-table-column prop="project_leader" label="负责人" align="center"></el-table-column>
            <el-table-column prop="invoice_type" label="发票类型" align="center"></el-table-column>
            <el-table-column prop="invoice_type" label="款项类型" align="center">
              <template slot-scope="scope">
                <el-tag size="mini" :type="scope.row.is_void===0?'success':'danger'">{{scope.row.is_void===0?'正常':'作废'}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="invoice_type" label="状态" align="center">
              <template slot-scope="scope">
                <el-tag size="mini" :type="scope.row.income_status===1?'success':'danger'">{{scope.row.income_status===1?'正常':'红冲'}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="income_type" label="回款性质" align="center"></el-table-column>
<!--            <el-table-column prop="status" label="是否审核" align="center">-->
<!--              <template slot-scope="scope">-->
<!--                <el-tag size="mini" :type="scope.row.status>3?'success':'danger'">{{scope.row.status>3?'已审':'未审'}}</el-tag>-->
<!--              </template>-->
<!--            </el-table-column>-->
            <el-table-column prop="update_time" label="操作时间" align="center" width="100"></el-table-column>
            <el-table-column label="操作 " align="center">
              <template slot-scope="scope">
<!--                <el-button type="danger" size="mini" v-if="ERP.isPermission(12002004001)" :disabled="redFlush(scope.row)" icon="el-icon-remove-outline" @click="setStatus(scope.row)">红冲</el-button>-->
<!--                <el-button type="danger" size="mini" v-if="ERP.isPermission(12002004002)" :disabled="redFlush2(scope.row)" icon="el-icon-remove-outline" @click="setStatus(scope.row)">审核红冲</el-button>-->
                <el-button type="primary" size="mini" icon="el-icon-info" @click="income(scope.row)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
        </div>
      </div>
    </div>



    <!-- 修改窗口 -->
    <el-dialog title="款项明细" :visible.sync="dialogVisible" :close-on-click-modal="false" width="800px">

      <div style="max-height: 500px;overflow-y: auto;">
        <el-descriptions column="1" border>
          <el-descriptions-item label="发票类型" prop="title">
            {{form.invoice_type}}
          </el-descriptions-item>
          <el-descriptions-item label="回款性质" prop="title">
            {{form.income_type}}
          </el-descriptions-item>
          <el-descriptions-item label="发票票号" prop="title">
            {{form.ticket_no}}
          </el-descriptions-item>
          <el-descriptions-item label="各项金额" prop="title">
            <el-table :data="multipleSelection">
              <el-table-column prop="party_a" label="客户名称" align="center" width="120"></el-table-column>
              <el-table-column prop="project_name" label="项目名称" align="center" width="120"></el-table-column>
              <el-table-column prop="entry_type_name" label="业务类型" align="center" width="90"></el-table-column>
              <!--              <el-table-column prop="name" label="费项名称" align="center" width="120"></el-table-column>-->
              <el-table-column prop="month" label="应收月份" width="100" align="center"></el-table-column>
              <el-table-column prop="amount" label="合同金额" align="center"></el-table-column>
              <el-table-column prop="invoice_amount" label="发票金额" align="center"></el-table-column>
            </el-table>
          </el-descriptions-item>
          <el-descriptions-item label="收款金额" prop="title">
            {{form.amount}}
          </el-descriptions-item>
          <el-descriptions-item label="收款时间" prop="title">
            {{form.income_time}}
          </el-descriptions-item>
          <el-descriptions-item label="状态" prop="title">
            <el-tag size="mini" :type="form.status===1?'success':'danger'">{{form.status===1?'正常':'红冲'}}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="款项类型" prop="title">
            <el-tag size="mini" :type="form.is_void===0?'success':'danger'">{{form.is_void===0?'正常':'作废'}}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="附件" prop="title">
            <upload-files-sysc :disabled="true" :host-url="host_url" :upload-url="host_url+'/contract/project/uploadFile'"  :limit="20" v-model="form.files"></upload-files-sysc>
          </el-descriptions-item>

          <el-descriptions-item label="备注" prop="title">
            {{form.remarks}}
          </el-descriptions-item>

        </el-descriptions>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
<!--        <el-button type="primary" @click="submitForm('form')" >确 定</el-button>-->
      </div>
    </el-dialog>

  </div>
</template>

<script>

import CommonHelp from "./common/CommonHelp";
import UploadFilesSysc from "./components/UploadFilesSysc";
import AreaTree from "./components/AreaTree";
import Api from "./common/Api";

export default {
  name:"ContractFinanceArrears",
  components: {AreaTree, UploadFilesSysc},
  data () {
    return {
      host_url:"",
      keyword: '',
      loading: false,
      contract_area_id:'',
      pageData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      pageChannelData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      dialogVisible:false,
      form:{
        name:"",
        invoice_type:"",
        income_type:"",
        ticket_no:"",
        finance_id:"",
        amount:0,
        income_time:"",
        files:"",
        status:1,
        is_void:0,
        remarks:"",
      },
      uploadUrl:"",
      month_money_list:[],
      project_list:[],
      month_value:"",
      year_value : "",
      multipleSelection:[],
      income_time : [],
      f_status:'3,4,5',
      time_type : 'contract_month',
      business_list:[],
      entry_type_name:"",
    }
  },
  created() {
    this.host_url=CommonHelp.getBaseURL();
    this.month_value=CommonHelp.date("YYYY-MM");
    // 当前月第一天和最后一天
    let firstDay = moment().startOf('month').format("YYYY-MM-DD");
    let lastDay = moment().endOf('month').format("YYYY-MM-DD");
    this.income_time = [
      firstDay , lastDay
    ];
    // this.getList()
    this.getBusinessList()
  },
  activated() {
    this.getList()
  },
  watch: {
    dialogVisible(val) {
      if(val == false) {
        this.multipleSelection = []
      }
    },
    "form.province_city_ids":function (n) {
      n&&n[0]&&(this.form.province_id=n[0])
      n&&n[1]&&(this.form.city_id=n[1])
      console.log(n)
    },
    "form.contract_area_ids":function (n) {
      console.log(n)
    },
    income_account(n){
      console.log(n);
    },
    finance_ids(n){
      console.log(n)
    }

  },
  computed:{
    income_account(){
      return this.multipleSelection.reduce(function(total, currentValue, currentIndex){
        total+=(currentValue.paid_amount*1);
        return total;
      }, 0)
    },
    finance_ids(){
      return this.multipleSelection.map(ret=>{return ret.id;})
    }
  },
  methods: {
    getFormData(data) {
      return Object.assign({
        id:'',
        name:"",
        invoice_type:"",
        income_type:"",
        ticket_no:"",
        finance_id:"",
        amount:0,
        income_time:"",
        files:"",
        status:1,
        is_void:0,
        remarks:"",
      }, data)
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    buildWhere(){
      let where={};
      this.keyword&&(where.name=this.keyword);
      this.contract_area_id&&(where.contract_area_ids=this.contract_area_id);
      if(this.time_type == 'contract_month'){
        where.month_value = this.month_value;
      }else{
        where.income_start_time = this.income_time[0];
        where.income_end_time = this.income_time[1];
      }
      this.month_value && (where.month=this.month_value);
      this.entry_type_name&&(where.entry_type_name=this.entry_type_name);
      return where;
    },
    getList() {
      var that=this;
      that.loading=true;
      let where = this.buildWhere();
      // where['qs']=1;
      CommonHelp.get("FinanceIncome/getList",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          res.data.list.map(ret=>{
            ret.is_end=ret.is_end === 1;
            ret.is_invoice=ret.is_invoice === 1;
            ret.is_paid=ret.is_paid === 1;
            ret.paid_amount=ret.paid_amount>0?ret.paid_amount:ret.invoice_amount;
            return ret;
          })
          that.pageData=res.data
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    income(item) {
      this.multipleSelection=[item];
      this.incomes(item);
    },
    incomes(data){
      let item=CommonHelp.reObject(data)
      this.form = this.getFormData({})
      this.form.ticket_no=item.invoice_ticket_no;
      this.form.name=item.invoice_name;
      this.form.invoice_type=item.invoice_type;
      this.form.income_type=item.income_type;
      this.form.amount= item.income_amount;
      this.form.status=item.income_status;
      this.form.files=item.income_files;
      this.form.is_void=item.is_void;
      this.form.income_time=item.income_time?this.date(item.income_time*1000):''
      this.form.finance_id=this.finance_ids[0];
      this.form.remarks=item.income_remarks;
      this.dialogVisible = true
    },
    // 导出报表
    download(){
      let where = this.buildWhere();
      Api.downloadIncomeArrears(where);
    },

    submitForm(formName) {
      var that=this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.formLoading = true
          let data = Object.assign({}, this.form)
          console.log(data)
          CommonHelp.post("FinanceIncome/save",data,res => {
            that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
            if(res.code) {
              that.dialogVisible = false
              that.multipleSelection=[];
              that.getList()
            }
            that.formLoading = false
          })
        } else {
          return false;
        }
      });
    },

    setFrom(data){
      var that=this;
      CommonHelp.post("FinanceInvoice/save",data,res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.multipleSelection=[];
          that.getList()
        }
      })
    },
    onAreaChange({data,pathData,ids}){
      this.form.province_city=data.mergename;
      this.form.province_city_ids=ids.join(',')
    },
    onContractAreaChange({data,pathData,ids}){
      let adrr=""
      pathData.map((ret,index)=>{
        adrr+=ret.name+(pathData[index+1]?' -> ':'')
      })
      this.form.contract_area=adrr;
      this.form.contract_area_ids=ids.join(',')
    },
    deleteFinance(item){
      var that=this;
      CommonHelp.post("Finance/delete", {id:item.id},res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.getList()
        }
      })
    },
    nodeClick1(n){
      this.contract_area_id=n.id;
      this.pageData={
        list:[],
        total:0,
        pageSize:20,
        page:1
      }
      this.getList()
    },
    exportExcel(){
      var that=this;
      let where={};
      this.keyword&&(where.name=this.keyword);
      this.contract_area_id&&(where.contract_area_ids=this.contract_area_id);
      CommonHelp.get("Finance/exportExcel",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          window.open(that.host_url + res.data)
        }
      })
    },
    importExcel(){
      var that=this;
      CommonHelp.uploadFile(ret=>{
        // console.log(ret);
        CommonHelp.post("Finance/importExcel",{ file_name:ret },res=>{
          if(res.code) {
            that.getList();
            if(res.data&&res.data.length){
              that.error_show_status=true;
              that.error_list=res.data;
            }
          }else {
            this.$message(res.msg);
          }
        })
      });
    },
    getBusinessList(){
      var that=this;
      CommonHelp.get("Business/getList",{
        page: 1,
        page_size: 100
      },res=>{
        if(res.code) {
          that.business_list=res.data.list
        }
      })
    },
    selectable(row,index){
      let is_paid=!!row.is_paid;
      let status=row.status === 3;
      let is_end=!row.is_end;
      return is_paid&&status&&is_end;
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },
    approve(){
      var that=this;
      that.$confirm('是否确定审核？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        CommonHelp.post("Finance/approve",{finance_ids:that.finance_ids.join(','),status:4},res=>{
          if(res.code) {
            that.getList();
            that.multipleSelection=[];
          }else {
            that.$message({
              type: 'warning',
              message: res.msg||"请求异常"
            });
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消审核'
        });
      });

    },
    revoke(item){
      var that=this;
      that.$prompt('您确定要撤销【'+item.name+'】吗？请填写撤销理由！', '撤销提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        CommonHelp.post("FinanceInvoice/revoke",{ id:item.income_id,remarks:value },res=>{
          if(res.code) {
            that.$message("撤销成功");
            that.getList();
          }else {
            that.$message(res.msg);
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消撤销'
        });
      });
    },
    revokeInfo(item){
      let data=JSON.parse(JSON.stringify(item));
      var that=this;
      that.getFinanceList(data.finance_ids,ret=>{
        ret.map(re=>{
          re.paid_amount=re.paid_amount>0?re.paid_amount:re.income_amount;
          return re;
        })
        that.multipleSelection=ret;
        data.files=JSON.parse(data.files);
        that.form_obj = that.getFormData(data);
        that.dialogVisible_info = true
      })
    },
    date(time){
      return CommonHelp.date("YYYY-MM-DD",time)
    },
    approveTable(item){
      this.multipleSelection=[item];
      this.approve();
    },
    toRound(val){
      return Math.round(val*(100))/(100)
    },
    setStatus(item){
      var that=this;
      that.$prompt('您确定要红冲吗？请填写撤销理由！', '撤销提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        CommonHelp.post("FinanceIncome/setStatus",{ id:item.income_id,status:0,remarks:value },res=>{
          if(res.code) {
            that.$message("红冲成功");
            that.getList();
          }else {
            that.$message(res.msg);
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消红冲'
        });
      });
    },
    redFlush(item){
      let income_status=!item.income_status;
      let status=Number(item.status)===4;
      return income_status||status;
    },
    redFlush2(item){
      let income_status=!item.income_status;
      let status=Number(item.status)!==4;
      return income_status||status;
    }
  }
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 120px - 230px );
  overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/ContractFinanceArrears.vue